export default "__VITE_ASSET__BKZzNhpk__"